import { AvailabilityType } from '@luminovo/api-contracts';
import { transEnum } from '@luminovo/frontend-utils';

import { availabilityTypeTranslations } from '../i18n';

export function formatAvailabilityType(availability: AvailabilityType): string {
    return transEnum(availability, availabilityTypeTranslations);
}
